export const mockAchievements = [
  {
    id: "firstPurchase",
    name: "First Steps",
    description: "Made your first domain purchase",
    icon: "🎉",
    rarity: "common",
    category: "trading",
    condition: "Purchase 1 domain",
    points: 10
  },
  {
    id: "firstSale",
    name: "First Sale",
    description: "Sold your first domain",
    icon: "💰",
    rarity: "common",
    category: "trading",
    condition: "Sell 1 domain",
    points: 10
  },
  {
    id: "speedDemon",
    name: "Speed Demon",
    description: "Sold a domain within 24 hours of listing",
    icon: "⚡",
    rarity: "rare",
    category: "trading",
    condition: "Sell domain within 24 hours",
    points: 50
  },
  {
    id: "portfolioKing",
    name: "Portfolio King",
    description: "Own 50+ domains simultaneously",
    icon: "👑",
    rarity: "epic",
    category: "portfolio",
    condition: "Own 50 domains",
    points: 100
  },
  {
    id: "tenXMaster",
    name: "10x Master",
    description: "Made a 10x return on a domain investment",
    icon: "📈",
    rarity: "epic",
    category: "trading",
    condition: "Achieve 10x ROI on single domain",
    points: 150
  },
  {
    id: "streakMaster",
    name: "Streak Master",
    description: "Traded every day for 30 consecutive days",
    icon: "🔥",
    rarity: "rare",
    category: "engagement",
    condition: "30 day trading streak",
    points: 75
  },
  {
    id: "top100",
    name: "Top 100",
    description: "Ranked in the top 100 traders",
    icon: "🏆",
    rarity: "rare",
    category: "leaderboard",
    condition: "Reach top 100 in any leaderboard",
    points: 50
  },
  {
    id: "highRoller",
    name: "High Roller",
    description: "Completed a single sale over $10,000",
    icon: "💎",
    rarity: "epic",
    category: "trading",
    condition: "Single sale over $10K",
    points: 100
  },
  {
    id: "influencer",
    name: "Influencer",
    description: "Gained 1,000+ followers",
    icon: "⭐",
    rarity: "rare",
    category: "social",
    condition: "Reach 1,000 followers",
    points: 75
  },
  {
    id: "fastSeller",
    name: "Fast Seller",
    description: "Average flip time under 14 days",
    icon: "🚀",
    rarity: "rare",
    category: "trading",
    condition: "Avg flip time < 14 days",
    points: 60
  },
  {
    id: "negotiator",
    name: "Master Negotiator",
    description: "Successfully completed 10 domain trades",
    icon: "🤝",
    rarity: "rare",
    category: "trading",
    condition: "Complete 10 domain swaps",
    points: 50
  },
  {
    id: "earlyBird",
    name: "Early Bird",
    description: "Purchased a domain within 1 hour of listing",
    icon: "🐦",
    rarity: "common",
    category: "trading",
    condition: "Buy domain within 1 hour of listing",
    points: 25
  },
  {
    id: "collector",
    name: "Collector",
    description: "Own domains from 5 different TLDs",
    icon: "📚",
    rarity: "common",
    category: "portfolio",
    condition: "Own domains from 5 TLDs",
    points: 30
  },
  {
    id: "socialButterfly",
    name: "Social Butterfly",
    description: "Posted 100 comments",
    icon: "🦋",
    rarity: "common",
    category: "social",
    condition: "Post 100 comments",
    points: 25
  },
  {
    id: "helpful",
    name: "Helpful",
    description: "Received 50 likes on your comments",
    icon: "💙",
    rarity: "common",
    category: "social",
    condition: "Get 50 comment likes",
    points: 20
  },
  {
    id: "legendary",
    name: "Legendary Trader",
    description: "Reached #1 on any leaderboard",
    icon: "🌟",
    rarity: "legendary",
    category: "leaderboard",
    condition: "Rank #1 overall",
    points: 500
  },
  {
    id: "diamondHands",
    name: "Diamond Hands",
    description: "Held a domain for over 1 year before selling",
    icon: "💎",
    rarity: "rare",
    category: "portfolio",
    condition: "Hold domain 1+ year",
    points: 75
  },
  {
    id: "sniper",
    name: "Sniper",
    description: "Won an auction in the final second",
    icon: "🎯",
    rarity: "rare",
    category: "trading",
    condition: "Win auction in last second",
    points: 50
  },
  {
    id: "diversified",
    name: "Diversified",
    description: "Own domains in 5 different categories",
    icon: "🌈",
    rarity: "common",
    category: "portfolio",
    condition: "Own domains from 5 categories",
    points: 30
  },
  {
    id: "profitMaster",
    name: "Profit Master",
    description: "Made $100K+ total profit",
    icon: "💰",
    rarity: "epic",
    category: "trading",
    condition: "Total profit over $100K",
    points: 200
  },
  {
    id: "cryptoExpert",
    name: "Crypto Expert",
    description: "Own 10+ crypto-related domains",
    icon: "₿",
    rarity: "rare",
    category: "portfolio",
    condition: "Own 10+ crypto domains",
    points: 60
  },
  {
    id: "topTrader",
    name: "Top Trader",
    description: "Reached top 10 on the leaderboard",
    icon: "🥇",
    rarity: "epic",
    category: "leaderboard",
    condition: "Reach top 10",
    points: 150
  },
  {
    id: "eliteMember",
    name: "Elite Member",
    description: "Subscribed to Elite tier",
    icon: "👑",
    rarity: "rare",
    category: "membership",
    condition: "Subscribe to Elite",
    points: 100
  },
  {
    id: "risingStart",
    name: "Rising Star",
    description: "Moved up 50+ ranks in one week",
    icon: "🌠",
    rarity: "rare",
    category: "leaderboard",
    condition: "Climb 50 ranks in 7 days",
    points: 75
  },
  {
    id: "helper",
    name: "Community Helper",
    description: "Helped 20+ users with advice",
    icon: "🤗",
    rarity: "common",
    category: "social",
    condition: "Give helpful advice 20 times",
    points: 40
  },
];

export default mockAchievements;
